export default __webpack_public_path__ + "static/media/kiril_xl.79b98428.jpg";